import { SponsorsIcon } from "./styles";

export const Clicampo = () => {
  return (
    <a href="https://www.clicampo.com.br/" target="_blank" rel="noreferrer">
      <SponsorsIcon
        width={101}
        height={124}
        viewBox="0 0 101 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M63.3509 42.8665C67.7225 33.9861 81.1453 20.6223 99.8628 38.2116C96.9939 41.7417 85.675 47.6145 63.3509 42.8665Z"
          fill="#189A66"
        />
        <path
          d="M72.869 32.457C81.9453 36.6118 88.227 38.2978 100.294 38.3488C96.8848 43.6334 85.6452 44.4915 81.0662 44.5804L68.7583 36.1452L72.869 32.457Z"
          fill="#09715A"
        />
        <path
          d="M30.9235 9.31615C59.4812 7.66947 64.373 25.9875 63.2493 35.3523C58.4023 36.0773 47.0416 36.2717 40.3746 31.2489C33.7075 26.2263 31.2959 14.5344 30.9235 9.31615Z"
          fill="#189A66"
        />
        <path
          d="M63.2465 35.4034C64.3714 26.019 59.4816 7.66359 30.9235 9.31674C46.5008 18.3655 53.4497 24.143 63.2465 35.4034Z"
          fill="#09715A"
        />
        <path
          d="M87.327 0C62.7273 4.87808 58.2531 22.6313 59.0909 30.8983C59.2896 37.9973 65.315 36.6624 68.3027 35.1076C87.6739 25.3876 89.0569 7.65256 87.327 0Z"
          fill="#189A66"
        />
        <path
          d="M68.5112 36.3824C87.702 26.3675 89.0524 8.05946 87.3287 0.157227C85.628 7.50135 70.948 28.9714 61.2581 36.5639L68.5112 36.3824Z"
          fill="#0C7249"
        />
        <path
          d="M47.4105 124C73.5946 124 94.821 102.766 94.821 76.5716C94.821 50.3777 73.5946 29.1433 47.4105 29.1433C21.2264 29.1433 0 50.3777 0 76.5716C0 102.766 21.2264 124 47.4105 124Z"
          fill="#FE4C4C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M83.8178 76.5499C83.8737 75.8902 82.9136 75.7545 82.687 76.3763C81.1566 80.5651 78.789 84.3983 75.7286 87.6421C72.6683 90.886 68.9793 93.4725 64.8866 95.2439C60.7939 97.0153 56.3832 97.9346 51.9236 97.9456C47.464 97.9565 43.0489 97.0591 38.9475 95.3078C34.8461 93.5566 31.1443 90.9883 28.068 87.7596C24.9917 84.5309 22.6053 80.7094 21.0543 76.5282C19.5033 72.347 18.8201 67.8936 19.0466 63.4398C19.273 58.9859 20.4043 54.6248 22.3714 50.6225C22.6755 50.0059 21.8859 49.3803 21.4302 49.895C17.6938 54.134 15.0164 59.199 13.6179 64.6739C12.2194 70.1488 12.1398 75.8774 13.3855 81.389C14.6312 86.9007 17.1668 92.0382 20.7839 96.3794C24.401 100.721 28.9965 104.142 34.1927 106.362C39.389 108.582 45.0379 109.538 50.6753 109.15C56.3126 108.763 61.7777 107.044 66.6215 104.134C71.4654 101.224 75.5497 97.2065 78.5391 92.4113C81.5285 87.6161 83.3376 82.1802 83.8178 76.5499L83.8178 76.5499Z"
          fill="url(#paint0_linear_1364_727)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1364_727"
            x1="89.391"
            y1="104.949"
            x2="3.14783"
            y2="66.1366"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="0.54719" stopColor="white" />
            <stop offset="0.77911" stopColor="white" stopOpacity="0.68964" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </SponsorsIcon>
    </a>
  );
};
